export type SinglePracticeLengthTranslationKey =
  | "study.exam_practice"
  | "study.practice"
  | "study.short_length";

export const getSinglePracticeLengthTranslationKey = ({
  isExamSimulation,
  isQuickPractice,
}: {
  isExamSimulation: boolean;
  isQuickPractice: boolean;
}): SinglePracticeLengthTranslationKey => {
  if (isExamSimulation) {
    return "study.exam_practice";
  }

  return isQuickPractice ? "study.short_length" : "study.practice";
};
